import React from "react"
import { HOME_SERVICES_LIST } from "../data"
import ServiceCard from "../components/ServicesCard"
import MainLayout from "../layouts/MainLayout"
import { Heading1 } from "../components/utils/Typography"
import Breadcrumb from "../components/utils/Breadcrumb"
import AgainGetQuote from "../components/AgainGetQuote"
import "../styles/global.scss"

function Services() {
  return (
    <div className="services">
      <MainLayout>
        <Breadcrumb
          arr={[
            { name: "Home", path: "/" },
            { name: "Services", path: "/services" },
          ]}
        />
        <Heading1
          heading="Our Services"
          subheading="we work with you, not for you"
        />
        <div className="container my-4">
          <div className="row">
            {HOME_SERVICES_LIST.map(s => (
              <ServiceCard {...s} />
            ))}
          </div>
        </div>

        <AgainGetQuote />
      </MainLayout>
    </div>
  )
}

export default Services
